import { render, staticRenderFns } from "./Communications.vue?vue&type=template&id=15809a6e&scoped=true"
import script from "./Communications.vue?vue&type=script&lang=ts"
export * from "./Communications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15809a6e",
  null
  
)

export default component.exports